import {loveStoryRecord} from "./loveStoryConst";
import getOneBundle, {BUNDLE_SMALL_NAME} from "../../BundleResourceConfig";
import {getOnePeopleById} from "../../config/WeChatPeopleConfig";
import data_control from "../../../../engines/libs/data_control";
import { getOneHeadUrlById } from "../../config/UserHeadConfig";
import NormalGameManager from "../../manager/NormalGameManager";
import O1HD from "../../../../engines/gameEngine";

const {ccclass, property} = cc._decorator;

/**
 * 记录预制体
 */
@ccclass
export default class loveStoryRecordPrefab extends cc.Component {

    @property({type:cc.Node,displayName:"男生头像背景"})
    manHeadBgNode : cc.Node = null;
    @property({type:cc.Node,displayName:"女头像背景"})
    manGirlBgNode : cc.Node = null;
    @property({type:cc.Sprite,displayName:"头像"})
    headSpiritNode : cc.Sprite = null;
    @property({type:cc.Label,displayName:"itemName"})
    lbItemName : cc.Label = null;
    @property({type:cc.Label,displayName:"用途"})
    lbYongtu : cc.Label = null;
    @property({type:cc.Label,displayName:"时间"})
    lbTime : cc.Label = null;
    @property({type:cc.Label,displayName:"金额"})
    lbFee : cc.Label = null;
    @property({type:cc.Node,displayName:"状态节点Array"})
    statusArray : cc.Node[] = [];

    private mPeopleName : string;
    private mRecordData : loveStoryRecord;

    onLoad(){

    }

    start(){

    }

    async bindData( peopleName : string , recordData : loveStoryRecord , width : number = null ){
        this.mPeopleName = peopleName;
        this.mRecordData = recordData;
        if ( width ) {
            this.node.width = width;
        }
        if ( recordData.peopleId == "自己" ) {
            //玩家
            this.manHeadBgNode.active = true;
            let meHead = "res/user/head/" + getOneHeadUrlById(NormalGameManager._instance.getGameData().userCurrHead);
            O1HD.getManagers().gameMgr.getCurrMode().bundle.load(meHead,cc.SpriteFrame,(err,imgs:cc.SpriteFrame)=>{
                if(err){
                    console.log(err);
                }else{
                    this.headSpiritNode.spriteFrame = imgs;
                }
            });
        }else{
            //女生
            this.manGirlBgNode.active = true;
            let people = getOnePeopleById( this.mRecordData.peopleId );
            let headUrl : string = people.headUrl;
            let bundle = await getOneBundle(BUNDLE_SMALL_NAME.WeChatGameBundle);
            bundle.load( headUrl,cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>{
                if(err){
                    console.log("加载头像失败 # loveStoryShareItem",err);
                    return;
                }
                this.headSpiritNode.spriteFrame = spr;
            });
        }
        this.lbYongtu.string = `${this.mRecordData.explain}`;
        let day = Math.floor( this.mRecordData.gameHour / 24 );
        let hour = this.mRecordData.gameHour % 24;
        let hourStr = `${hour}`;
        if ( hour < 10 ) {
            hourStr = `0${hour}`;
        }
        let minuteStr = `${this.mRecordData.gameMinute}`;
        if ( this.mRecordData.gameMinute < 10 ){
            minuteStr = `0${this.mRecordData.gameMinute}`
        }
        this.lbTime.string = `第${ day+1 }天 ${hourStr}:${minuteStr}`;
        this.lbFee.string = `${data_control.getNumberFormat( this.mRecordData.coin )}`;
        if ( this.mRecordData.type == 1 ) {
            //存入
            this.lbItemName.string = `存款记录`;
        }else{
            //取出
            this.lbItemName.string = `提款申请`;
            switch ( this.mRecordData.agreeStatus ) {
                case 1 :
                    //审核中
                    this.statusArray[1].active = true;
                    break;
                case 2:
                    this.statusArray[2].active = true;
                    //成功
                    break;
                case -1:
                    this.statusArray[0].active = true;
                    //失败
                    break;
            }
        }

    }


}
